import React from 'react';
import { MessageSquare, Shield } from 'lucide-react';

export const CommunitySection = () => (
  <section className="py-16">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="bg-white rounded-xl shadow-sm p-8">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-bold mb-4">Join Our Excel Community</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Connect with Excel enthusiasts, share your knowledge, and get help from experts.
          </p>
        </div>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="space-y-4">
            <div className="flex items-start space-x-4 p-4 bg-gray-50 rounded-lg">
              <MessageSquare className="h-6 w-6 text-green-600 mt-1" />
              <div>
                <h3 className="font-semibold">Active Discussions</h3>
                <p className="text-gray-600">Engage in meaningful conversations about Excel techniques</p>
              </div>
            </div>
            <div className="flex items-start space-x-4 p-4 bg-gray-50 rounded-lg">
              <Shield className="h-6 w-6 text-green-600 mt-1" />
              <div>
                <h3 className="font-semibold">Expert Support</h3>
                <p className="text-gray-600">Get help from certified Excel professionals</p>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 p-6 rounded-lg">
            <h3 className="text-xl font-semibold mb-4">Join the Discussion</h3>
            <div className="space-y-4">
              <input
                type="text"
                placeholder="Search discussions..."
                className="w-full px-4 py-2 rounded-lg border focus:outline-none focus:ring-2 focus:ring-green-600"
              />
              <button className="w-full bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700">
                Start a New Topic
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);